<!--
 * @Author: liuchang
 * @Date: 2019-08-14 20:27:01
 * @Description:
 -->
<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: 'App',
    data () {
        return {};
    },
    created () {},
    methods: {},
    mounted () {
    }
};
</script>
<style lang="scss">
    body {
        padding: 0 !important;
        max-width: 100% !important;
        max-height: 100% !important;
    }
</style>



// WEBPACK FOOTER //
// ./src/App.vue